// extracted by mini-css-extract-plugin
export default {"main":"AdminPage_main__MCcoj","btn":"AdminPage_btn__O-CSY","block":"AdminPage_block__ubRry"};